const MediaLibrary = () => {
  return (
    <div>
      <h1>Media Library</h1>
    </div>
  );
};

export default MediaLibrary;
